import React, { useEffect, useRef, useState } from 'react';
import { Modal } from "react-bootstrap";
import isNull from '../../../../../../../../../../../../utils/NullChecking'
import { ServerRequestProtected } from '../../../../../../../../../../../../utils/ServerDataRequest';
import NotificationHandler from '../../../../../../../../../../../../utils/NotificationHandler';
import { enumUtil } from '../../../../../../../../../../../../utils/Enum';
import FormValidator from '../../../../../../../../../../../../utils/FormValidator';
import ModalHeader from '../../../../../../../../../../../Setup/Shared/ModalHeader';
import DeleteConfirmatiom from '../../../../../../../../../../../General/DeleteConfirmation';
import Loader from '../../../../../../../../../../../shared/Loader/Loader';

const AddNewSocialHistory = (props) => {
    const { isOpenSocialHistory, onClose, socialHistoryData, setIsRecordSaved, patientID, IsEditAllowed, onDeleteSocialHistory } = { ...props }
    const API_URL = enumUtil.controller.General
    let SocialHistory_Modal = {
        Notes: socialHistoryData.Notes || "",
    }
    let SocialHistory_Modal_Default = {
        Notes: "",
    }
    let valModal = {}
    let ValidationModal = {
        NotesVal: "",
    }
    const [isOpenDeleteAlert, setisOpenDeleteAlert] = useState(false);
    const [socialHistoryID, setSocialHistoryID] = useState();
    const [socialHistoryValidationModal, setSocialHistoryValidationModal] = useState(ValidationModal)
    const [socialHistorySaveUpdateModal, setSocialHistorySaveUpdateModal] = useState({})
    const [mainSocialHistoryModal, setMainSocialHistoryModal] = useState(SocialHistory_Modal);
    const [isLoading, setIsLoading] = useState(false)
    const [onSocialHistorySaved, setOnSocialHistorySaved] = useState(false)
    const [del, setDel] = useState(false)
    const [searchDropdown, setSearchDropdown] = useState(false);
    const [is, setIs] = useState(false);
    console.log("AddNewProblem", props)

    useEffect(() => {
        // setPracticeID(PracticeID)
        if (socialHistoryData.PatientHistoryID != null) {
            setDel(true)
            setSocialHistoryID(socialHistoryData.PatientHistoryID)
        } else {
            if (!onSocialHistorySaved) {
                setSocialHistoryID(0);
                setDel(false)
            } else {
                setDel(true)
            }
        }
        if (!isNull(socialHistoryID)) {
            // setIsLoading(true)
            // ServerRequestProtected(API_URL + "/FindByID", 'post', {
            //     "ID": socialHistoryID,
            //     "TableName": enumUtil.enumAPITableName.SocialHistory
            // }).then((response) => {
            //     setIsLoading(false)
            //     setMainSocialHistoryModal(response)
            // }).catch((error) => {
            //     NotificationHandler(error.response.data, enumUtil.enumtoaster.error)
            //     setIsLoading(false)
            // })
        }
    }, [socialHistoryID])

    const SocialHistoryValidation = async () => {
        let ValidationModal = {
            NotesVal: FormValidator(
                mainSocialHistoryModal.Notes,
                enumUtil.enumValidationType.Required,
                'Social History',
            ),

        }
        await setSocialHistoryValidationModal(ValidationModal)
        valModal = ValidationModal
    }
    const addNewSocialHistory = () => {
        props?.setSocialHistoryData({ PatientHistoryID: null })
        setSocialHistoryID(null)
        handleClear();
    }
    const handleSaveSocialHistory = async (type) => {
        if(!IsEditAllowed) return;
        await SocialHistoryValidation()
        let validation = FormValidator([valModal], enumUtil.enumValidationType.NullCheck)
        if (validation) {
            NotificationHandler('Fill Required Fields', enumUtil.enumtoaster.error)
            return
        } else {
            setSocialHistorySaveUpdateModal(socialHistorySaveUpdateModal)
            let data = {
                PatientID: patientID,
                HistoryType: "Social History",
                HistorySubType: "Social History",
                ...socialHistorySaveUpdateModal
            };

            let saveModal = {
                TableName: enumUtil.enumAPITableName.PatientHistory,
                ID: socialHistoryID,
                Data: { ...data },
            }
            setIsLoading(true)
            ServerRequestProtected(API_URL + "/SaveSingleRecord", 'post', saveModal)
                .then((response) => {
                    if (!isNull(response.id)) {
                        setIsLoading(false)
                        NotificationHandler(`Record Saved Successfully`, enumUtil.enumtoaster.success)
                        setIsRecordSaved(true)
                        setOnSocialHistorySaved(true)
                        setSocialHistoryID(response.id)
                        if (type === "Add Another") {
                            addNewSocialHistory();
                        } else {
                            onClose();
                        }
                        // onClose()
                    }
                }).catch((error) => {
                    setIsLoading(false)
                    console.log('error', error);
                    NotificationHandler(error.response.data, enumUtil.enumtoaster.error)
                })
        }
    }

    const handleClear = () => {
        setMainSocialHistoryModal(SocialHistory_Modal_Default);
        setSocialHistorySaveUpdateModal({});
    }

    const handleChange = (e) => {
        let { name, value } = e.target
        let modal = { ...mainSocialHistoryModal };
        let saveModal = { ...socialHistorySaveUpdateModal }
        modal[name] = value
        setMainSocialHistoryModal(modal)
        for (var property in SocialHistory_Modal) {
            if (name === property) {
                saveModal[name] = value
            }
        }
        setSocialHistorySaveUpdateModal(saveModal)
    }

    const SocialHistoryName = () => {
        return (
            <p className="heading">Add New Social History</p>
        )
    }

    const handleDeleteModal = () => {
        setisOpenDeleteAlert(true)
    }
    const onCloseDelete = () => {
        setisOpenDeleteAlert(false);
    }
    const onDelete = () => {
        props?.setIsRecordSaved(true);
        setisOpenDeleteAlert(false);
        onClose();
    }

    let DeleteConfirmation = "";
    if (isOpenDeleteAlert) {
        DeleteConfirmation = (
            <DeleteConfirmatiom
                isOpenAlert={isOpenDeleteAlert}
                hideReason={true}
                API_URL={API_URL}
                TableName={enumUtil.enumAPITableName.PatientHistory}
                ID={String(socialHistoryID)}
                onCloseDelete={onCloseDelete}
                onClose={onDelete}
            />
        );
    }
    let DeletePopup = "";
    if (del) {
        DeletePopup = (
            <button
                className={
                    props?.IsDeleteAllowed
                      ? 
                    "btn-icon-transparent"
                      : 
                      "btn-icon-transparent delete-btn-disabled"
                } onClick={handleDeleteModal}>
                <span className="icon"><i className="icon-delete"></i></span>
                <span className="title">Delete</span>
            </button>
        );
    }
    const textareaRef = useRef(null);

    const adjustTextareaHeight = () => {
        const textarea = textareaRef.current;
        if (textarea) {
            textarea.style.setProperty('height', 'auto', 'important');
            textarea.style.setProperty('height', `${textarea.scrollHeight}px`, 'important');
        }
    };
    useEffect(() => {
        adjustTextareaHeight();
    }, [mainSocialHistoryModal.Notes]);
    return (
        <Modal show={isOpenSocialHistory} onHide={isOpenSocialHistory} backdrop="static" keyboard={false} centered dialogClassName="hk-modal-v1 ar_ehr_problems ar_new-popup-design">
            <Modal.Body>
                {DeleteConfirmation}
                {isLoading ? <Loader /> : null}
                {/* <ModalHeader HeaderName={SocialHistoryName} DeletePopup={''} isClosed={onClose} /> */}
                <ModalHeader HideAuditIcon={"PatEncounter"} HeaderName={SocialHistoryName} isOpenDeleteAlert={isOpenDeleteAlert} onCloseDelete={onCloseDelete} DeletePopup={DeletePopup} isClosed={onClose} />
                <div className="">
                    <div className=''>
                        <div className={`input my-2 ${socialHistoryValidationModal.NotesVal ? 'error' : ''}`}>
                            <label className="pb-3px">Notes</label>
                            <textarea
                                className="form-control overflow-hidden"
                                ref={textareaRef}
                                onInput={adjustTextareaHeight}
                                id='Notes'
                                name='Notes'
                                rows="3"
                                onChange={handleChange}
                                value={mainSocialHistoryModal.Notes}
                            />
                            {socialHistoryValidationModal.NotesVal}
                        </div>
                    </div>
                </div>
            </Modal.Body>
            {/* <div className="d-flex align-items-center pb-15 px-10 pt-2 br-top-1 za_br_light  ar_footer justify-content-end gap-2">
                <button className='btn btn-outline  px-10 h-100 dark-clr' onClick={onClose}>Cancel</button>
                <button className='btn btn-validate px-10 h-100' onClick={handleSaveSocialHistory}>Save</button>
            </div> */}
            <div className='d-flex align-items-center pb-15 px-10 pt-2 br-top-1 za_br_light  ar_footer justify-content-between'>
                <button className='btn btn-outline  px-10 h-100 dark-clr' onClick={onClose}>Cancel</button>
                <div className="d-flex align-items-center gap-2">
                <button className={`btn btn-outline  px-10 h-100 validate-color ${IsEditAllowed ? '' : 'disable'}`} onClick={() => handleSaveSocialHistory("Add Another")}>Save & Add Another</button>
                <button className={`btn btn-validate px-10 h-100 ${IsEditAllowed ? '' : 'disable'}`} onClick={handleSaveSocialHistory}>Save</button>
                </div>
            </div>
        </Modal>
    )
}

export default AddNewSocialHistory